export const SOMETHING_WENT_WRONG = "Something went wrong. Please try again later.";
export const CONTACT_SUPPORT_MESSAGE =
  "Contact our Support team at support@miviewis.com for help.";
export const PAGE_ACCESS_FAIL =
  "It seems there is a problem accessing the page you are looking for.";
